import React from "react"
import { notify } from "react-notify-toast"

import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber }  from 'react-phone-number-input'

import FormField from "../../Components/FormField/FormField"

//redux
import { connect } from "react-redux"

require("./PersonalDetails.css")

class EmergencyContactForm2 extends React.Component {
  constructor(props) {
    super(props)

    // console.log(props)

    if (props === null) {
      window.location = "./login"
    }
  }

  // componentDidMount = () => {
  // 	document.getElementById("emergency_contact_name").value = this.props
  // 		.emergency_contact_name
  // 		? this.props.emergency_contact_name
  // 		: "";

  // 	document.getElementById("emergency_contact_lastname").value = this.props
  // 		.emergency_contact_lastname
  // 		? this.props.emergency_contact_lastname
  // 		: "";

  // 	document.getElementById("emergency_contact_mobile_number").value = this
  // 		.props.emergency_contact_mobile_number
  // 		? this.props.emergency_contact_mobile_number
  // 		: "";

  // 	document.getElementById("emergency_contact_relationship").value = this.props
  // 		.emergency_contact_relationship
  // 		? this.props.emergency_contact_relationship
  // 		: "";

  // 	document.getElementById("medical_needs").value = this.props.medical_needs
  // 		? this.props.medical_needs
  // 		: "";
  // };

  // validateMobileNumber() {
  //   let isValid = false
  //   if (isNaN(this.props.emergency_contact_mobile_number)) {
  //     notify.show("please type valid number", "error")
  //   } else if (
  //     this.props.emergency_contact_mobile_number.length === 10 &&
  //     this.props.emergency_contact_mobile_number.substring(0, 2) === "04"
  //   ) {
  //     isValid = true
  //   } else {
  //     notify.show(
  //       "please use australian number eg:04XXXXXXXX (10 Digit)",
  //       "error"
  //     )
  //   }
  //   return isValid
  // }

  render() {
    return (
      <div className="row">
        <div className="col-lg-6 col-md-12">
          <div className="auth-text-top mb-md-5">
            <div className="form-group">
              <FormField
                label="First Name"
                id="emergency_contact_name"
                name="emergency_contact_name"
                value={this.props.state.emergency_contact_name}
                onChange={this.props.handleStateChange}
                required
                placeholder="Emergency contact - First Name"
              />

              <FormField
                label="Last Name"
                id="emergency_contact_lastname"
                name="emergency_contact_lastname"
                value={this.props.state.emergency_contact_lastname}
                onChange={this.props.handleStateChange}
                required
                placeholder="Emergency contact - Last Name"
              />

              <PhoneInput
                label="Mobile"
                inputComponent={FormField}
                id="emergency_contact_mobile_number"
                name="emergency_contact_mobile_number"
                value={this.props.state.emergency_contact_mobile_number}
                onChange={this.props.handleNumberChange}
                required
                placeholder="Enter phone number"
                defaultCountry="AU"
                international
              />
            </div>
          </div>
        </div>

        <div className="col-lg-6 col-md-12">
          <div className="auth-text-top mb-5">
            <div className="form-group">
              <FormField
                label="Relationship to you"
                id="emergency_contact_relationship"
                required
                name="emergency_contact_relationship"
                value={this.props.state.emergency_contact_relationship}
                onChange={this.props.handleStateChange}
                placeholder="Indicate your relationship"
              />

              <FormField
                label="Allergies / Medication / Conditions (If Any)"
                rows="5"
                id="medical_needs"
                name="medical_needs"
                value={this.props.state.medical_needs}
                onChange={this.props.handleStateChange}
                placeholder="Please indicate if you have a medical condition"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

//Map root state to this component
const mapStateToProps = function (state) {
  return {
    user: state.user.user,
  }
}

export default connect(mapStateToProps)(EmergencyContactForm2)
// export default EmergencyContactForm2;
